import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';

export const useStyles = makeStyles<Theme>(
    theme => ({
        sidebar: {
            zIndex: 10002,
            position: 'absolute',
            top: 50,
            bottom: 0,
            width: 280,
            // https://lukechannings.com/blog/2021-06-09-does-safari-15-fix-the-vh-bug/
            // Helps for all mobile devices
            height: 'calc(100vh - 50px) - env(safe-area-inset-bottom)',
            overscrollBehavior: 'none',
            backgroundColor: theme.customization.background.G50,
            transition: 'all 0.3s ease-out',
            WebkitTransition: '-webkit-transform 0.3s ease-out, width 0.3 ease-out',
            willChange: 'transform',
            overflowY: 'auto',
            left: 0,
            transform: 'translateX(-100%)',
            WebkitTransform: 'translateX(-100%)',
        },
        sidebarFullWidth: {
            width: '100%',
        },
        overlay: {
            zIndex: 10001,
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0,
            visibility: 'hidden',
            transition: 'opacity 0.3s ease-out, visibility 0.3s ease-out',
            backgroundColor: 'rgba(0,0,0,0.3)',
        },
        sidebarIsOpen: {
            transform: 'translateX(0%)',
            WebkitTransform: 'translateX(0%)',
            boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.15)',
        },
        overlayIsOpen: {
            opacity: 1,
            visibility: 'visible',
        },
    }),
    { classNamePrefix: 'navigation-drawer' }
);
